import React from 'react';
import { Tooltip, Whisper } from 'rsuite';
import Modal, { ModalProps } from 'rsuite/lib/Modal';
import { ButtonPrimary } from '..';
import { LoadingSpinerArea } from '../LoadingSpinner';
import { useModalOptimizationSummary } from './hooks/useModalEditedPreceOptimization';
import styles from './style.module.scss';

export type ModalOptimizationSummaryProps = Omit<ModalProps, 'onHide'> & {
    onHide?: () => void;
};

export const ModalOptimizationSummary = ({ className = '', onHide, ...props }: ModalOptimizationSummaryProps) => {
    const { handleCloseModal, redirectToOptimization, modalIsOpen, optimizationSummaryData } = useModalOptimizationSummary();

    const storesNameTooltip = optimizationSummaryData?.filters?.storesName
    const storesName = optimizationSummaryData?.filters?.storesName?.slice(0, 2)?.join(', ') || [];
    return (
        <Modal className={['info-modal', className].join(' ')} onHide={handleCloseModal} show={modalIsOpen} {...props}>
            <main className={styles['modal-container']}>
                <Modal.Header>
                    <Modal.Title className="font-size-200-semibold">
                        <h2 className="font-size-400-semibold">Resumo da otimização aplicada</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={styles.content}>
                        <section className={styles.section}>
                            <div>
                                <h2>categoria otimizada</h2>
                                <p>{optimizationSummaryData?.filters?.categories}</p>
                            </div>
                            <div>
                                <h2>Lojas a otimizar</h2>
                                <Whisper
                                    disabled={!storesNameTooltip?.length || storesNameTooltip?.length < 2}
                                    trigger="hover"
                                    placement="right"
                                    speaker={<Tooltip>{storesNameTooltip?.join(', ')}</Tooltip>}>
                                    <p>{storesNameTooltip?.length
                                        && storesNameTooltip?.length > 2
                                        ? storesName + '...' : storesName}</p>
                                </Whisper>
                            </div>
                        </section>

                        <section className={styles.section}>
                            <div>
                                <h2>objetivo</h2>
                                <p>{optimizationSummaryData?.coordinates?.objective}</p>
                            </div>
                            <div>
                                <h2>Loja controle</h2>
                                <p>{optimizationSummaryData?.filters?.controlStoreName}</p>
                            </div>
                        </section>
                        <div className={styles.divider} />

                        <section className={styles.section}>
                            <div>
                                <h2>restrições de margem</h2>
                                <p>{optimizationSummaryData?.coordinates?.margin?.min} | {optimizationSummaryData?.coordinates?.margin?.max}</p>
                            </div>
                            <div>
                                <h2>restrição de competitividade</h2>
                                <p>{optimizationSummaryData?.coordinates?.competitiveness?.min} |
                                    {optimizationSummaryData?.coordinates?.competitiveness?.max}</p>
                            </div>
                        </section>
                        <div className={styles.divider} />

                        <section className={styles.section}>
                            <div>
                                <h2>frequência</h2>
                                <p>{optimizationSummaryData?.scheduleOptimizationPrices?.period?.value}</p>
                            </div>
                            <div>
                                <h2>dia da semana</h2>
                                <p>{optimizationSummaryData?.scheduleOptimizationPrices?.period?.options}</p>
                            </div>
                        </section>

                        <section className={styles.section}>
                            <div>
                                <h2>última execução</h2>
                                <p>{optimizationSummaryData?.scheduleOptimizationPrices?.execution?.lastExecutionDate}</p>
                            </div>
                            <div>
                                <h2>próxima execução</h2>
                                <p>{optimizationSummaryData?.scheduleOptimizationPrices?.execution?.nextExecutionDate}</p>
                            </div>
                        </section>

                        <section className={styles.section}>
                            <div>
                                <h2>início vigência</h2>
                                <p>{optimizationSummaryData?.scheduleOptimizationPrices?.validity?.start?.startDate}</p>
                            </div>
                            <div>
                                <h2>final vigência</h2>
                                <p>{optimizationSummaryData?.scheduleOptimizationPrices?.validity?.end?.endDate}</p>
                            </div>
                        </section>

                        <section className={styles.section}>
                            <div>
                                <h2>responsável</h2>
                                <p>{optimizationSummaryData?.responsible}</p>
                            </div>
                        </section>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <ButtonPrimary skin="blue" theme="ghost" type="button" onClick={handleCloseModal}>
                        FECHAR
                    </ButtonPrimary>
                    <ButtonPrimary skin="blue" theme="filled" onClick={redirectToOptimization} type="submit" autoFocus>
                        VER OTIMIZAÇÃO
                    </ButtonPrimary>
                </Modal.Footer>
            </main>
            <LoadingSpinerArea size="sm" area="saved-filter" height={'100%'} />
        </Modal>
    );
};
